module.exports = __webpack_public_path__ + "static/assets/0329b9057e1fda8a1a0bc8e52f105ea1.svg";